import { I18n } from "@assets/strings";
import React from "react";
import { useLocation } from "react-router";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { useCurrentProfile, useIsPerson } from "@domain/currentProfile/hooks";
import { Post } from "@domain/post/post";
import { useModalTools } from "@ui/modals/modalContext";
import { useConfirmation } from "@ui/modals/useConfirmation";
import { gap, mobile } from "@ui/styles/utils";
import { SimpleMenuContent } from "@ui/components/menus/simpleMenuContent";
import { EditPostModal } from "./editPostModal";
import { EditReferencePostModal } from "@ui/components/post/reference/editReferencePostModal";

interface PostMenuProps extends React.HTMLAttributes<HTMLDivElement> {
	post: Post;
	onDelete?: () => void;
}
export const PostMenu: React.FC<PostMenuProps> = ({ post, onDelete, ...htmlProps }) => {
	const { postService, userService } = useServices();
	const currentProfile = useCurrentProfile();
	const location = useLocation();
	const { createModal } = useModalTools();
	const askDeleteConfirmation = useConfirmation(I18n.t("post.delete.title"), I18n.t("delete"));
	const isAuthor = useIsPerson(post.author);
	const history = useHistory();
	const { followedByMeSince } = post;
	return (
		<Container {...htmlProps}>
			<SimpleMenuContent
				onEdit={
					!isAuthor
						? undefined
						: () =>
								createModal((close) =>
									post.type === "BASIC" ? (
										<EditPostModal close={close} initialPost={post} />
									) : (
										<EditReferencePostModal close={close} shared={post} initialPost={post} />
									)
								)
				}
				onDelete={
					!isAuthor
						? undefined
						: () =>
								askDeleteConfirmation(async () => {
									await postService.delete(post.id);
									onDelete?.();
									postService.fetchFeed(location.pathname.includes(Path.MyProfile) ? currentProfile?.id : undefined);
								})
				}
				reportInfos={
					isAuthor
						? undefined
						: {
								contentId: post.id,
								contentType: "POST",
							}
				}
				disinterest={
					isAuthor || !!followedByMeSince
						? undefined
						: async () => {
								await userService.disinterestUser(post.author.id);
								history.go(0);
							}
				}
			/>
		</Container>
	);
};

const Container = styled.div`
	${gap(10)};

	@media ${mobile} {
		${gap(20)};
	}
`;
